module.exports = __webpack_public_path__ + "img/welcome.17686aac.png";